import { Module } from 'vuex'
import { DossierState, state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/app/common/types/root-state.type'

export const dossierStore: Module<DossierState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
